module.exports = __webpack_public_path__ + "img/019-logo.256ea814.png";